module.exports = __webpack_public_path__ + "static/img/7.8ef6438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news17/7.png
// module id = 6yDj
// module chunks = 1